import {
  FETCH_COMMUNITY_MEMBERS,
  FETCH_COMMUNITY_MEMBERS_SUCCESS,
  FETCH_COMMUNITY_MEMBERS_FAILURE,
} from 'src/modules/community/communityMembers/actionTypes';

export const initialState = {
  isLoading: true,
  data: {
    members: [],
    total: 0,
  },
  currentPage: 1,
  currentFilter: '',
};

export const reducer = (state, action) => {
  switch (action.type) {
    case FETCH_COMMUNITY_MEMBERS:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_COMMUNITY_MEMBERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        currentFilter: action.currentFilter,
        currentPage: action.currentPage,
      };
    case FETCH_COMMUNITY_MEMBERS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
  }
  return state;
};
